import React from 'react';
import { connect } from 'react-redux';
import { get, isEmpty } from 'lodash/fp';
import Tooltip from 'components/shared/Tooltip';
import addModifiers from 'utils/add_modifiers';
import * as actions from 'actions/pathBuilder';
import * as selectors from 'selectors/pathBuilder';
import EditPermissionNeeded from 'components/shared/EditPermissionNeeded';
import UpdatePathButton from './UpdatePathButton';
import DiscardChangesButton from './DiscardChangesButton';
import SaveDraftButton from './SaveDraftButton';
import PublishPathButton from './PublishPath';

const PathActions = ({
  hasUnsavedChanges,
  isPublished,
  isEditing,
  hasDraft,
  userCanManageContent,
  isCertification,
  features,
  ...props
}) => (
  <div className="PathBuilder-actions">
    {/* Non-Editing Mode */}
    {!isEditing && userCanManageContent && (
      <Tooltip text={props.canEdit.reason && props.canEdit.reason} inline>
        <button
          type="button"
          className={addModifiers('NewButton', [
            'blue',
            'tallAndWide',
            'center',
          ])}
          onClick={props.toggleEditing}
          disabled={!props.canEdit.value}
        >
          {!isCertification && t('paths.path_builder.button_edit_path')}
          {isCertification &&
            t('certifications.certification_builder.button_edit_certification')}
        </button>
      </Tooltip>
    )}
    {!isEditing && !isPublished && userCanManageContent && (
      <PublishPathButton />
    )}

    {!isEditing && !userCanManageContent && <EditPermissionNeeded />}

    {/* Editing Mode */}

    {isEditing && hasDraft && (
      <DiscardChangesButton hasUnsavedChanges={hasUnsavedChanges} />
    )}

    {isEditing && !isPublished && (
      <SaveDraftButton hasUnsavedChanges={hasUnsavedChanges} />
    )}

    {isEditing && isPublished && (
      <UpdatePathButton hasUnsavedChanges={hasUnsavedChanges} />
    )}
  </div>
);

const mapStateToProps = ({ pathBuilder, ...state }) => ({
  hasUnsavedChanges: selectors.hasUnsavedChanges(pathBuilder),
  hasDraft: !isEmpty(pathBuilder.lastRevision),
  isPublished: !!get('publishedAt.date')(pathBuilder),
  isEditing: selectors.modeSelectors.isEdit(pathBuilder),
  canEdit: selectors.canEditPath(pathBuilder),
  userCanManageContent: pathBuilder.permissions.editPath,
  isCertification: !!get('certification')(pathBuilder),
});

const mapDispatchToProps = {
  toggleEditing: actions.toggleEditingMode,
};

export default connect(mapStateToProps, mapDispatchToProps)(PathActions);
